import React, { Fragment } from "react";
import BlogCard from "../../components/Blogs/BlogCard";
import Sidebar from "../../components/Blogs/BlogSidebar";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";

const Blog = () => {
  const blogPosts = [
    {
      image: "https://skinandshape.com/wp-content/uploads/2024/08/Reasons-for-Sudden-Hair-Loss-in-Males.png",
      title:
        "How Effective Is Finasteride for Hair Loss? Your Essential Guide Before Starting Treatment",
      description:
        "Hair loss is a prevalent issue affecting millions of men and women worldwide.",
        date: "21 days",
        link: "/blogs/1/How-Effective-Is-Finasteride-for-Hair-Loss",
    },
    {
      image: "https://www.nicepng.com/png/detail/437-4375140_weight-loss-png-weight-loss-png-file.png",
      title:
        "The Truth About Weight Loss Pills: Myths, Facts, and What You Should Know.",
      description:
        "Losing weight can often feel like an overwhelming and frustrating journey.",
      date: "19 days",
      link: "/blogs/2/The-Truth-About-Weight-Loss-Pills",
    },
  ];

  return (
    <Fragment>
      <Navbar />
      <div className="container mt-5">
        <div className="row">
          {/* Blog Cards Container - 9 columns */}
          <div className="col-12 col-md-9">
            <div className="row">
              {blogPosts.map((post, index) => (
                <div key={index} className="col-12 col-sm-6 mb-4">
                  <BlogCard
                    image={post.image}
                    title={post.title}
                    description={post.description}
                    date={post.date}
                    link={post.link}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Sidebar - 3 columns */}
          <div className="col-12 col-md-3">
            <Sidebar />
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};

export default Blog;
